/** Store contact details from https://vgentlao.com/ */
export const STORE_CONTACT = {
  brand: "VG Mart",
  phone: "+856 20 8875 9945",
  phoneHref: "tel:+8562088759945",
  email: "VgEntLao@gmail.com",
  emailHref: "mailto:vgentlao@gmail.com",
  address: "Sokpaluang Road, Vientiane, Laos",
  hours: "Everyday / 08:00 – 22:00",
  facebookHandle: "VgEntLao",
  facebookUrl: "https://www.facebook.com/vgentlao",
} as const;
